export default __webpack_public_path__ + "static/34_31-7884ecb3f30efb0918cd9bc77124262e.png";